<template>

    <div class="rich-text-editor" :style="heightStyle">
        <ckeditor
            :editor="editor"
            :model-value="modelValue"
            @update:model-value="$emit('update:modelValue', $event)"
            :config="editorConfig"
            v-bind="$attrs" />
    </div>

</template>


<script>

import ClassicEditor, { TOOLBAR_PRESETS } from '@/utils/CustomCKEditor';

export default {
    name: 'RichTextEditor',

    props: {
        modelValue: { type: String, default: '' },
        toolbar:    { type: String, default: 'base' },
        height:     { type: [String, Number], default: '' },
        config:     { type: Object, default: () => ({}) }
    },

    emits: ['update:modelValue'],

    data: function () {
        return {
            editor: ClassicEditor
        };
    },

    computed: {
        editorConfig: function () {
            return Object.assign({}, TOOLBAR_PRESETS[this.toolbar] || TOOLBAR_PRESETS.base, this.config);
        },
        heightStyle: function () {
            if (this.height === '' || this.height === null || this.height === undefined) {
                return {};
            }
            var h = typeof this.height === 'number' ? this.height + 'px' : this.height;
            return { '--rte-height': h };
        }
    }
}

</script>


<style>

.rich-text-editor .ck-editor__editable_inline {
    height: var(--rte-height);
    overflow-y: auto;
}

</style>
